import { Component, Input, OnInit } from "@angular/core"
import { ColorPaletteService } from "@shared/services/color-palette.service"
import { IconImageService } from "@shared/services/icon-image.service"
import { FlowColors } from "../flow-tab/flow-tab.component"

@Component({
  selector: "flow-checkbox",
  templateUrl: "./flow-checkbox.component.html",
  styleUrl: "./flow-checkbox.component.scss",
  standalone: false,
})
export class FlowCheckboxComponent implements OnInit {
  @Input() checkedImg: string = this.iconService.Icon.check
  @Input() color: FlowColors = "brand"
  @Input() disabled: boolean = false
  @Input() destructive: boolean = false
  @Input() checked: boolean = false

  public focused: boolean = false

  constructor(public iconService: IconImageService, public colorService: ColorPaletteService) {}

  ngOnInit(): void {
    document.getElementById("checkbox").setAttribute("tabindex", "0")
  }

  public setCheck() {
    this.checked = !this.checked
  }

  public setFocus(focus: boolean) {
    this.focused = focus
  }

  public checkFocusBorder(): boolean {
    if (this.focused && !this.disabled && !this.destructive) {
      return true
    } else {
      return false
    }
  }

  public isCheckBoxChecked(): boolean {
    if (this.checked && !this.disabled && !this.destructive) {
      return true
    } else {
      return false
    }
  }

  public getCheckboxBorder(): string {
    if (this.checkFocusBorder()) {
      switch (this.color) {
        case "neutral":
          return this.colorService.neutral700
        case "orange":
          return this.colorService.orange700
        case "yellow":
          return this.colorService.yellow700
        case "green":
          return this.colorService.green700
        case "teal":
          return this.colorService.teal700
        case "blue":
          return this.colorService.blue700
        case "brand":
          return this.colorService.brand700
        case "purple":
          return this.colorService.purple700
        case "pink":
          return this.colorService.pink700
      }
    } else {
      return ""
    }
  }

  public getCheckboxBackGroundColor(): string {
    if (this.isCheckBoxChecked()) {
      switch (this.color) {
        case "neutral":
          return this.colorService.neutral700
        case "orange":
          return this.colorService.orange700
        case "yellow":
          return this.colorService.yellow700
        case "green":
          return this.colorService.green700
        case "teal":
          return this.colorService.teal700
        case "blue":
          return this.colorService.blue700
        case "brand":
          return this.colorService.brand700
        case "purple":
          return this.colorService.purple700
        case "pink":
          return this.colorService.pink700
      }
    } else if (this.checked && this.destructive) {
      return this.colorService.red600
    } else {
      return ""
    }
  }
}
